import { Link, graphql } from 'gatsby'
import Sites from '@toasttab/shared/src/data/Sites.json'
import { SiteSchema } from '@toasttab/shared/src/interfaces/Site.Schema'
import React, { useEffect, useState } from 'react'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'
import MainLayout from '@toasttab/shared/src/layout/MainLayout'
import { useSiteMetadata } from '../hooks/use-site-metadata'
import { PageContext, PageContextProps } from '@toasttab/shared/src/hooks/usePageContext'
import Hero from '../components/homepage/hero'
import { getLanguageByCountryCode, getSiteIdByLanguageCode } from '@toasttab/shared/src/utils/siteUtils'
import SEO from '@toasttab/shared/src/components/molecules/SEO/SEO'
import Card from '../components/card'

export const query = graphql`
  query ($locale: String!, $region: String!, $slug: String!) {
    allContentfulSupportHomepage(
      filter: {
        node_locale: { eq: $locale }
        regions: { elemMatch: { country: { eq: $region } } }
        slug: { eq: $slug }
      }
    ) {
      edges {
        node {
          title
          slug
          regions {
            title
            country
            hero {
              ...Hero
            }
            content {
              ...CTABanner
            }
            metaTitle
            metaDescription
            canonical
            slugOverride
            isIndexed
            node_locale
          }
          __typename
          contentful_id
        }
      }
    }
    site {
      siteMetadata {
        twitterUsername
        title
        siteUrl
        hostName
        pathPrefix
        image
        description
      }
    }
  }
`

const cardData = [
  {
    title: 'Help articles',
    description: 'Find answers when you need them with our searchable help articles and FAQs.',
    buttonText: 'Find answers',
    imageSrc: 'path-to-help-articles-image.jpg',
    buttonLink: '#'
  },
  {
    title: 'Mobile support',
    description: 'Connect with support wherever you are with the Toast Now app.',
    buttonText: 'Get app',
    imageSrc: 'path-to-mobile-support-image.jpg',
    buttonLink: '#'
  },
  {
    title: 'Check system status',
    description: 'View current system performance, maintenance updates, and service status.',
    buttonText: 'View status',
    imageSrc: 'path-to-system-status-image.jpg',
    buttonLink: '#'
  },
  {
    title: 'Chat with us',
    description: "Access Toast's new integrated chat support on toasttab.com or by downloading the Toast Now app.",
    buttonText: 'Log in to chat',
    imageSrc: 'path-to-chat-support-image.jpg',
    buttonLink: '#'
  },
  {
    title: 'Live training',
    description: 'Participate in live Toast Classroom sessions with experts for real-time learning.',
    buttonText: 'Register now',
    imageSrc: 'path-to-live-training-image.jpg',
    buttonLink: '#'
  },
  {
    title: 'On-demand training',
    description: 'Learn at your own pace with self-guided courses, learning paths, and videos.',
    buttonText: 'Start learning',
    imageSrc: 'path-to-on-demand-training-image.jpg',
    buttonLink: '#'
  },
  {
    title: 'Product updates',
    description: 'Stay up to date on the latest innovation here at Toast.',
    buttonText: "See what's new",
    imageSrc: 'path-to-product-updates-image.jpg',
    buttonLink: '#'
  },
  {
    title: 'Community forum',
    description: 'Connect with your peers to find answers, ask questions, and share tips and insights.',
    buttonText: 'Join now',
    imageSrc: 'path-to-community-forum-image.jpg',
    buttonLink: '#'
  }
]

// markup
const Index = (props: any) => {
  const siteMetadata = useSiteMetadata()
  const { language, region } = useI18next()

  const context: PageContextProps = {
    title: 'Toast | Restaurant Point of Sale & Management System',
    url: '/',
    region: 'US'
  }

  const { data } = props
  const node = data.allContentfulSupportHomepage.edges[0].node
  const title = node.title
  const siteId = getSiteIdByLanguageCode(getLanguageByCountryCode(language))
  const regionSite = node.regions.filter((r: any) => r.country == region)[0]
  const hero = regionSite.hero
  const content = regionSite.content
  return (
    <PageContext.Provider value={context}>
      <MainLayout siteId={siteId} siteMetadata={siteMetadata} packageName="support" currentLanguage={language}>
        <Hero {...hero} />
        <div className="pb-12 w-full flex justify-center">
          <div className="w-full lg:w-[1200px] mx-5 lg:mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
            {content.map((card: any, index: number) => {
              return (
                <Card
                  key={index}
                  title={card.heading}
                  description={card.description}
                  image={card.image}
                  buttons={card.ctas}
                />
              )
            })}
          </div>
        </div>
      </MainLayout>
    </PageContext.Provider>
  )
}

export default Index

export const Head = () => {
  const { language } = useI18next()
  const localizedEntries = Sites.sites
    .filter((site) => site.contentfulRegionCode !== 'US')
    .map((site: any) => {
      return {
        slug: '',
        language: site.language,
        siteId: site.regionCode
      }
    })
  return (
    <>
      <title>{`Toast | Restaurant Point of Sale & Management System`}</title>
      <meta
        name="description"
        content={`Toast is a restaurant point of sale and management system that helps restaurants improve operations, increase sales and create a better guest experience.`}
      />
    </>
  )
  // return (
  //   <SEO
  //     title="Toast | Restaurant Point of Sale & Management System"
  //     description="Toast is a restaurant point of sale and management system that helps restaurants improve operations, increase sales and create a better guest experience."
  //     language={getLanguageByCountryCode(language)}
  //     localizedEntries={localizedEntries}
  //     pathname=""
  //   ></SEO>
  // )
}
